import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Button,
  Grid,
} from "@material-ui/core";
import serviciosTablero from "utils/serviciosTablero";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const CheckListAction = ({
  open,
  onClose,
  onCreateChecklist,
  tarjeta,
  setCargando,
}) => {
  const classesTablero = useStylesTablero();
  const [title, setTitle] = useState("");
  const [error, setError] = useState("");

  const handleCreateChecklist = () => {
    if (!title.trim()) {
      setError("El título no puede estar vacío.");
      return;
    }

    setError("");

    const datosChecklist = {
      titulo: title,
      idtarjeta: tarjeta,
    };
    serviciosTablero.addChecklist(
      (status, mensaje, data) => {
        if (status === 1) {
          onCreateChecklist(data); // Devuelve los datos creados
          onClose(); // Cierra el diálogo
        } else {
          setError(mensaje || "Error al crear el checklist.");
        }
      },
      setCargando,
      datosChecklist
    );
  };
  return (
    <>
      <TextField
        label="Título"
        variant="outlined"
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={{ marginBottom: "16px" }}
        className={classesTablero.field}
      />
      
      <DialogActions style={{ justifyContent: "flex-end" }}>
          <Grid item>
            <Button
              onClick={onClose}
              className={classesTablero.btnCancelar}
              style={{ margin: "5px 0px 0 10px" }}
            >
              CANCELAR
            </Button>
          </Grid>
          <Grid>
            <Button
              onClick={handleCreateChecklist}
              className={classesTablero.btnAceptar}
              style={{ margin: "5px 0px 0 10px" }}
            >
              CONFIRMAR
            </Button>
          </Grid>

      </DialogActions>
    </>
  );
};

export default CheckListAction;
